import React from 'react';

import { NavItemText } from './NavItemText';
import type { AppSection } from '../ui-interfaces';

interface LeftNavItemLabelProps {
  section: AppSection;
  selected?: boolean;
}

export function LeftNavItemLabel({ section }: LeftNavItemLabelProps): JSX.Element {
  return <NavItemText>{section}</NavItemText>;
}
